<template>
	<div v-if="!isUseInBlance" class="balanceBar">
		<div v-if="isShowAmount" class="amount_show">
			<div class="needPay">
				需支付：
				<span style="color: #f56c6c">{{ priceComputed(payAmount) }}</span>
				元
			</div>
			<div v-if="charges" class="needPay">
				（包含手续费：
				<span style="color: #f56c6c">{{ priceComputed(charges) }}</span>
				元）
			</div>
			<div class="balance">
				当前营销账户余额总数：
				<span style="color: #f56c6c">{{ priceComputed(surplus) }}</span>
				元
			</div>
		</div>
		<div v-else class="balance">
			当前营销账户余额总数：<span :style="{ color: 'red' }">{{ showSurplus }}</span
			><span class="input_suffix">元</span>
		</div>
		<div :style="{ width: '260px', whiteSpace: 'nowrap' }">
			<el-button
				class="plain-button"
				:class="{ redTextTip }"
				type="primary"
				size="mini"
				plain
				@click="goToRecharge"
			>
				去充值
			</el-button>
			<el-button
				class="plain-button"
				type="primary"
				size="mini"
				plain
				:loading="surplusLoading"
				@click="refreshSurplus"
			>
				刷新余额
			</el-button>
		</div>

		<waitRechargeDialog :visible.sync="waitRechargeVisible" @update="refreshSurplus" />
		<red-rain-verification ref="redRainVerification" :money="money" />
	</div>
</template>

<script>
import waitRechargeDialog from '@/components/dialog/waitRechargeDialog.vue';
import redRainVerification from '@/components/dialog/redRainVerification.vue';

import { activity, errors, upload, rainActivity as rainService, prize, trxorder } from '@services';
import waitUntil from 'ourwill-feutil/common/waitUntil';
import { mapState } from 'vuex';
import { division, multiply } from '@/utils/math';
import {
	CHARGE_RATIO,
	CHARGE_RATIO_PAY_TO_USER,
	MAX_PRICE,
	chargeComputed,
	amountComputed,
} from '@/utils/priceSetting';

export default {
	components: {
		waitRechargeDialog,
		redRainVerification,
	},
	props: {
		isLive: {
			type: Boolean,
			default: true,
		},
		isShowAmount: {
			type: Boolean,
			default: false,
		},
		amount: {
			type: Number,
			default: 0,
		},
		usedPayToUser: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			surplus: 0,
			surplusLoading: false,
			redTextTip: false,
			waitRechargeVisible: false,
			redTextTimeout: null,

			money: '',
		};
	},
	computed: {
		...mapState({
			currentActive: (state) => state.state.currentActive,
			company: (state) => state.company,
			loginUserId: (state) => state.company.loginUserId,
			isCompanyMode: (state) => state.company.isCompanyMode,
			haveTrueSelfMch: (state) => state.state.haveTrueSelfMch,
			payToUser: (state) => state.state.payToUser,
			isAccount: (state) => state.company.isAccount,
		}),
		showSurplus() {
			return division(this.surplus, 100);
		},
		payAmount() {
			if (!this.amount || isNaN(Number(this.amount)) || this.amount == 0) {
				return 0;
			}
			return amountComputed(this.amount, CHARGE_RATIO);
		},
		charges() {
			if (!this.amount || isNaN(Number(this.amount)) || this.amount == 0) {
				return 0;
			}
			return chargeComputed(this.amount, CHARGE_RATIO);
		},
		ratio() {
			if (this.isUseInBlance) {
				return CHARGE_RATIO_PAY_TO_USER;
			} else {
				return CHARGE_RATIO;
			}
		},
		isUseInBlance() {
			// 企业版下，配置商户并且商户开通了企业付款到零钱
			// 2022-12-15 修改，去掉企业版限制
			return this.usedPayToUser || (this.haveTrueSelfMch && this.payToUser);
		},
	},
	mounted() {
		this.getTrxorder();
	},
	methods: {
		priceComputed(amount) {
			if (isNaN(Number(amount))) {
				return 0;
			} else {
				return (amount / 100).toFixed(2);
			}
		},
		async getTrxorder() {
			// 直播间里面获取创建者
			if (this.isLive) {
				// 此处获取的余额是 主账号的, 通过getTotalAmount是登录账号人的
				waitUntil(
					() => this.currentActive.userId,
					async () => {
						try {
							this.surplusLoading = true;
							const { ok, data } = await trxorder.getTotalAmountByUserId(this.currentActive.userId);
							this.surplusLoading = false;
							if (ok) {
								this.surplus = data.data.marketingSurplus;
							}
						} catch (e) {
							errors(e);
						}
					},
					() => {
						console.info('activity info is faild');
					},
					50,
					200,
				);
			} else {
				// 非直播间获取登录企业主账号，或者自己的
				waitUntil(
					() => this.company.loginUserId,
					async () => {
						try {
							this.surplusLoading = true;
							let userId = this.company.isCompanyMode
								? this.company.info.userId
								: this.company.loginUserId;
							const { ok, data } = await trxorder.getTotalAmountByUserId(userId);
							this.surplusLoading = false;
							if (ok) {
								this.surplus = data.data.marketingSurplus;
							}
						} catch (e) {
							errors(e);
						}
					},
					() => {
						console.info('company info is faild');
					},
					50,
					200,
				);
			}
		},
		async refreshSurplus() {
			await this.getTrxorder();
		},
		goToRecharge() {
			// 直播间里面获取创建者
			if (this.isLive) {
				// 非创建者
				if (this.currentActive.impowerType != 0) {
					this.$message.error('请联系创建者充值！');
					return;
				}
			} else {
				if (this.isCompanyMode && this.isAccount) {
					this.$message.error('请使用主账号充值！');
					return;
				}
			}

			let routePath = this.$router.resolve({ name: 'user.income' });
			this.waitRechargeVisible = true;
			window.open(`${routePath.href}?from=interaction`, '_blank');
		},
		getSurplus() {
			return {
				yuan: this.showSurplus,
				fen: this.surplus,
			};
		},
		async testDeduction(amount, notFen = false, id = null) {
			amount = Number(amount);
			if (notFen) {
				// 转化为分
				amount = multiply(amount, 100);
			}
			let deductionAmount = amountComputed(amount, this.ratio);
			// console.log(deductionAmount);
			// 余额抵扣改为必选, 当前余额小于总金额时，提示余额不足
			if (this.surplus < deductionAmount) {
				clearTimeout(this.redTextTimeout);
				this.redTextTip = true;
				this.redTextTimeout = setTimeout(() => {
					this.redTextTip = false;
				}, 3000);
				// 余额不足 流程结束
				this.$message.error('余额不足，请充值');
				return {
					next: false,
				};
			} else {
				const priceData = {
					amount: amount, // 实际到账金额 单位 分
					surplus: deductionAmount, // 余额抵扣金额， 单位 分
					charge: deductionAmount - amount, // 手续费金额， 单位 分
					id,
				};
				let result = await this.$refs.redRainVerification.checkSend(priceData);
				return {
					...result,
					amount,
					deductionAmount,
				};
			}
		},
	},
};
</script>

<style lang="less">
.balanceBar {
	display: flex;
	align-items: center;
	font-size: 14px;
	color: #5d6574;
	position: relative;
	z-index: 30;
	.amount_show {
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		font-size: 14px;
		color: #5d6574;
		.needPay {
			color: #1d2129;
			white-space: nowrap;
		}
	}
	.input-box {
		display: flex;
		align-items: center;
	}
	.balance {
		margin-right: 18px;
		white-space: nowrap;
	}
}
</style>
